import tw, { styled } from 'twin.macro';

export const RichTextElementWrapper = styled.div`
  ${tw`font-normal leading-normal text-textColor`}

  .table-responsive {
    ${tw`break-all`}

    table {
      ${tw`min-w-[50%] mt-3 mb-8`}
      ${tw`border border-solid border-grey border-collapse`}
    }

    tr:first-of-type {
      ${tw`text-center bg-grey-light`}
    }

    th,
    tr,
    td {
      ${tw`border border-solid border-grey border-collapse`}
      ${tw`py-[5px] px-[10px]`};
      ${tw`break-words`};
      ${tw`max-w-[800px]`};
    }

    * {
      ${tw`max-w-[800px]`};
    }
  }

  h2,
  h3,
  h4,
  h5,
  h6 {
    ${tw`font-bold text-neutrals-n9`}
  }

  h2 + h3,
  h3 + h4,
  h4 + h5,
  h5 + h6 {
    ${tw`mt-0`}
  }

  h2 {
    ${tw`text-md`}
    ${tw`pb-2`}
  }
  h3 {
    ${tw`text-m pb-1`}
  }
  h4 {
    ${tw`text-base pb-1`}
  }
  h5 {
    ${tw`text-base pb-1`}
  }
  h6 {
    ${tw`text-sm pb-1`}
  }

  p {
    ${tw`mb-6`}

    & + pre {
      ${tw`-mt-4`}
    }
  }

  img {
    ${tw`max-w-[100%] max-h-full`}
  }

  ol,
  ul {
    ${tw`mb-8 pl-10`}
  }

  ul {
    ${tw`list-disc`}
  }

  ol {
    ${tw`list-decimal`}
  }

  li {
    ${tw`mb-4`}
  }

  a.external-link,
  a.internal-link,
  a.email-link {
    ${tw`text-link no-underline`}
    ${tw`font-medium`}
    ${tw`hover:text-link-hover`}

    &.external-link {
      span,
      strong,
      em {
        ${tw`hover:text-link-hover`}
      }

      svg {
        ${tw`fill-neutrals-n7 hover:fill-secondary-s4-purple mb-1`}
        ${tw`w-4`}
      }
    }
  }

  code {
    ${tw`inline-block`}
    ${tw`text-neutrals-n8`}
    ${tw`bg-neutrals-n4`}
    ${tw`text-sm`}
    ${tw`[word-break: break-word]`}
    ${tw`px-[4px]`}
    font-family: monospace;
  }

  figure > pre {
    ${tw`p-[16px]`}
    ${tw`bg-[#FAFCFF]`}
    ${tw`border border-dashed border-borderColor`}
    ${tw`leading-8`}
    & > code {
      ${tw`p-0`}
      ${tw`bg-[#FAFCFF]`}
    }
  }

  blockquote {
    ${tw`border-l-4 border-[#e4e4e4] border-solid leading-normal`}
    ${tw`mx-0 my-[20px] px-[15] py-0`}
  }

  figure {
    ${tw`mb-8`}
  }
`;
